import { createStorageValue } from '@interhyp/platform-storage';
import { z } from 'zod';
import { portalInterimNamespace } from '../namespaces';
/**
 * Save the current relevant intent (because of routing or after creating a new intent)
 */
export const currentIntentValue = createStorageValue({
    namespace: portalInterimNamespace,
    schema: z.object({
        intentId: z.string(),
        userId: z.string(),
    }),
    type: 'local',
    id: Symbol('current-intent-value'),
});
